import innovate from '../../assets/OurMission/Innovate UK logo 1.png'
import erdf from '../../assets/OurMission/ERDF Logo1 1.png'
import dwp from '../../assets/OurMission/dwplogo 1.png'
import edinburgh from '../../assets/OurMission/edinburgh 1.png'
import kent from '../../assets/OurMission/kent-county-council-logo 1.png'
import angila from '../../assets/OurMission/anglia-ruskin-university-aru-logo-vector 2.png'
import aberdeen from '../../assets/OurMission/university-of-aberdeen-logo-vector 2.png'
import west from '../../assets/OurMission/Navbar-westminster-logo 2.png'
import universityEdinburgh from '../../assets/OurMission/University_of_Edinburgh-Logo.wine 2.png'
import OurPatners from './ourPatners'

const sponsorGroups = [
  {
    title: 'Funded to deliver our vision',
    description:
      "We've been repeatedly backed by esteemed institutions, innovation agencies and authorities.",
    sponsors: [
      {
        src: innovate,
        className:
          'w-[121px] h-[39px] 2xl:w-[178px] 2xl:h-[58px] 3xl:w-[252px] 3xl:h-[82px]',
      },
      {
        src: erdf,
        className:
          'w-[141px] h-[78px] 2xl:w-[297px] 2xl:h-[166px] 3xl:w-[209px] 3xl:h-[116px]',
      },
      {
        src: dwp,
        className:
          'w-[113px] h-[92px] 2xl:w-[166px] 2xl:h-[136px] 3xl:w-[236px] 3xl:h-[192px]',
      },
      {
        src: edinburgh,
        className:
          'w-[142px] h-[47px] 2xl:w-[210px] 2xl:h-[69px] 3xl:w-[297px] 3xl:h-[98px]',
      },
      {
        src: kent,
        className:
          'w-[106px] h-[106px] 2xl:w-[158px] 2xl:h-[158px] 3xl:w-[224px] 3xl:h-[224px]',
      },
    ],
  },
  {
    title: 'Leading UK advancements in the field of computer science and law.',
    description:
      'We’ve delivered industry research in collaboration with leading British institutions.',
    sponsors: [
      {
        src: angila,
        className:
          'w-[92px] h-[62px] 2xl:w-[136px] 2xl:h-[92px] 3xl:w-[193px] 3xl:h-[130px]',
      },
      {
        src: universityEdinburgh,
        className:
          'w-[148px] h-[40px] 2xl:w-[218px] 2xl:h-[59px] 3xl:w-[309px] 3xl:h-[84px]',
      },
      {
        src: west,
        className:
          'w-[118px] h-[36px] 2xl:w-[173px] 2xl:h-[54px] 3xl:w-[245px] 3xl:h-[76px]',
      },
      {
        src: aberdeen,
        className:
          'w-[109px] h-[48px] 2xl:w-[161px] 2xl:h-[70px] 3xl:w-[229px] 3xl:h-[100px]',
      },
    ],
  },
]

const OurSponsors = () => {
  return (
    <div className='flex flex-col items-start gap-[40px] self-stretch lg:gap-[100px] 2xl:gap-50 3xl:gap-[150px]'>
      {sponsorGroups.map(({ title, description, sponsors }, index) => (
        <div
          className='flex flex-col items-start self-stretch gap-5 px-[20px] lg:px-20 2xl:gap-10 2xl:px-[120px] 3xl:px-[190px]'
          key={`${title}-${index}`}
        >
          <div className='flex flex-col items-start self-stretch gap-3 2xl:gap-5'>
            <div className='flex flex-col items-start self-stretch gap-2 2xl:gap-4'>
              <p className='text-[#58C1B3] font-medium leading-normal tracking-wide text-xs lg:text-sm lg:font-medium 2xl:text-base 2xl:leading-6 3xl:text-lg 3xl:font-bold'>
                {title}
              </p>
              <h3 className='text-[#001A3D] font-medium lg:font-bold lg:text-lg lg:leading-6 lg:tracking-wide 2xl:font-bold 2xl:leading-8 3xl:font-bold 3xl:text-[32px] 3xl:leading-normal'>
                {description}
              </h3>
            </div>
            <div className='self-stretch h-1 lg:h-2 bg-[linear-gradient(90deg,#24547C_0%,#3DC3D8_100%)]'></div>
          </div>
          <div className='flex p-0 px-5 justify-center items-center content-center gap-5 self-stretch flex-wrap lg:justify-between lg:px-10 lg:items-center lg:self-stretch lg:flex-nowrap'>
            {sponsors.map(({ src, className }, i) => (
              <img key={className} src={src} className={className} alt='' />
            ))}
          </div>
        </div>
      ))}
      <OurPatners />
    </div>
  )
}

export default OurSponsors
